import * as moment from 'moment/moment';

export class TimeRange {
    min: moment.Moment;
    max: moment.Moment;

    constructor();
    constructor(json: any);
    constructor(json?: any) {
        if (json) {
            this.min = json.min;
            this.max = json.max;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/domain/models/timeRange.ts